import React from 'react'
import ProPublicaHead from '../../includes/ProPublicaHead'
import PixelPing from '../../analytics/PixelPing'
import * as pym from 'pym.js'
import '../../../styles/main.scss'


class WidgetLayout extends React.Component {
  componentDidMount() {
    this.pymChild = new pym.Child({polling: 500})
  }

  render() {
    let meta = this.props.config.meta.concat([
      {name: 'robots', content: 'noindex'}
    ])

    return (<div className="content-dark">
      <ProPublicaHead meta={meta} title={this.props.config.title} />
      {this.props.children}
      <PixelPing />
    </div>)
  }
}

export default WidgetLayout
